import { Mark, SnowflakeIndices } from '@/pages/CompanyReport/redux/interface';

export enum SummaryRiskStatus {
  InsufficientData = 'insufficientData', //All the risks are null or no risk found
  HasPassedAllRisks = 'hasPassedAllRisks', //All possible risks with value===true
  HasNotFailedAnyRisk = 'hasNotFailedAnyRisk', //No risks with value===false (there can be null)
  HasFailedRisks = 'hasFailedRisks', //At least one risk with value===false
}

export interface AnalysisChecks {
  [SnowflakeIndices.VALUE]: Mark[];
  [SnowflakeIndices.FUTURE]: Mark[];
  [SnowflakeIndices.PAST]: Mark[];
  [SnowflakeIndices.HEALTH]: Mark[];
  [SnowflakeIndices.DIVIDEND]: Mark[];
}

export interface RiskProps {
  name: string;
  hash: string;
  sectionName: string;
}
